import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
    signUpEmail: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.ACCOUNT_RESEND_ATTEMPT_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.ACCOUNT_RESEND_ATTEMPT_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.ACCOUNT_RESEND_ATTEMPT_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_ACCOUNT_CHANGE_DATA:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
}
